import { LitElement, html, css } from '@hh/global.js'

class HHRadioWrapper extends LitElement {
  static properties = {
    disabled: {
      type: Boolean,
      reflect: true,
    },
  }

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()

    this.checked = this.querySelector('input')?.checked
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  firstUpdated() {
    this.disabled = this.input.disabled
    this.checked = this.input.checked
  }

  onChange(e) {
    this.checked = e?.target?.checked
  }

  get input() {
    const slot = this.shadowRoot?.querySelector(`slot[name='input']`)
    return slot?.assignedNodes()[0] ?? null
  }

  render() {
    return html`
      <slot @change="${this.onChange}" name="input" part="input"></slot>
      <slot name="label" part="label"></slot>
    `
  }

  static styles = css`
    *,
    *::before,
    *::after {
      box-sizing: border-box;
    }

    :host {
      display: inline-flex;
      align-items: center;
      column-gap: var(--hh-column-gap, 0.5rem);
      font: var(--hh-font);
      color: var(--hh-color);
    }

    ::slotted(input) {
      appearance: none;
      touch-action: none;
      margin: 0;
      width: var(--hh-width, 2.4rem);
      height: var(--hh-height, 2.4rem);
      border: 1px solid var(--hh-color);
      border-radius: var(--hh-border-radius, 50%);
      position: relative;
      cursor: pointer;
    }

    ::slotted(input)::before {
      content: '';
      pointer-events: none;
      width: calc(var(--hh-width, 2.4rem) / var(--hh-dot-to-border-ratio, 2));
      height: calc(var(--hh-height, 2.4rem) / var(--hh-dot-to-border-ratio, 2));
      border-radius: var(--hh-border-radius, 50%);
      background-color: var(--hh-color);
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) scale(0);
      -webkit-transform: translate(-50%, -50%) scale(0);
    }

    :host(:not([disabled]):hover),
    :host(:not([disabled]):hover) ::slotted(input),
    :host([checked]) ::slotted(input:checked),
    :host([checked]) ::slotted(label) {
      border-color: var(--hh-color-hover, #646464);
      color: var(--hh-color-hover);
    }

    :host(:not([disabled]):hover) ::slotted(input)::before,
    ::slotted(input:checked)::before {
      background-color: var(--hh-color-hover);
    }

    ::slotted(input:checked)::before {
      transform: translate(-50%, -50%) scale(1);
      -webkit-transform: translate(-50%, -50%) scale(1);
      display: block;
    }

    ::slotted(input:focus) {
      border: 1px solid var(--hh-color-hover, #646464) !important;
      color: var(--hh-color-hover);
    }

    ::slotted(input:disabled) {
      border-color: var(--hh-color-input-border-disabled);
      cursor: not-allowed;
      color: var(--hh-color-input-radio-disabled);
    }

    ::slotted(label) {
      cursor: pointer;
    }

    :host([disabled]) ::slotted(label) {
      cursor: not-allowed;
      color: var(--hh-color-input-radio-disabled);
    }
  `
}

customElements.define('hh-radio-wrapper', HHRadioWrapper)
